import React, { FormEvent, useCallback, useState,useContext, useMemo, useEffect } from 'react'
import RegisterOscContext from '../../../context/RegisterContext'
import useApi from '../../../hooks/useApi'
import { SubmitButton } from '../../../Korbantech/components/Buttons/SubmitButton'
import { OscInput } from '../OscInputs/OscInput'
import { RespondenetFields } from './RespondentFields'
import { Osc } from '../../../types/Osc'
import { SpinnerLoad } from '../../Loading/SpinnerLoad'
import { SuccessAlert } from '../../Alerts/SuccessAlert'
import { TelInput } from '../OscInputs/TelInput'
import {UrlInput} from "../OscInputs/UrlInput";

export const ContactFields = ({ oldData,update,isPublic }: Props) => {

    const { setStep } = useContext(RegisterOscContext)
    const {  osc } = useContext(RegisterOscContext)

    const [newData , setNewData] = useState<Osc | undefined>(undefined)
    const [isSuccess,setIsSuccess] = useState<boolean>(false)
    const [load,setLoad] = useState<boolean>(false)

    const api = useApi();

    const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        e.currentTarget.checkValidity()
        setLoad(true)
        if (!e.currentTarget) return
        const data = new FormData(e.currentTarget)

        if (update && osc) {
            setLoad(true)
            data.append('_method', 'PATCH')
            if (isPublic){
                await api.post(`/client/me/contact`, data).then(res => {
                    setNewData(res.data);
                    setIsSuccess(true)
                }).catch(console.log)
            }else {
                await api.post(`admin/osc/${osc.id}/contact`, data).then(res => {
                    setNewData(res.data);
                    setIsSuccess(true)
                }).catch(console.log)
            }
            setLoad(false)
            return
        }

        if(!osc) return

        await api.post(`/osc/${osc.id}/contact`, data).then(res => {
            setStep(3)
        }).catch(console.log)
        setLoad(false)

    }, [api, setStep, osc, update, isPublic])


    const data = useMemo(():Osc | undefined=>{

        let data:Osc|undefined = undefined

        if(osc) data = osc

        if(oldData) data = oldData

        if(newData) data = newData

        return data

    },[oldData,osc,newData])

    useEffect(()=>{
        if(osc?.contact) setStep(3);
    },[osc,setStep])

    return (
        <>
            {update && <div className='font-semibold text-xl mb-2'>Contato</div>}
            {isSuccess && <SuccessAlert message='Contato atualizado' closeAlert={()=>setIsSuccess(false)} />}
            <form onSubmit={handleSubmit} className={`${data && 'border-l-4 border-green-600 pl-4 pr-4 rounded-lg '}`} >
                <div className='grid gap-x-6 gap-y-4 grid-cols-1 md:grid-cols-2 text-gray-800 '>
                    <TelInput label={'Telefone da organização'} necessary
                    required
                    name={'osc_phone'} defaultValue={data?.contact?.osc_phone && data?.contact.osc_phone} type="tel"
                    />
                    <TelInput label={'Celular / Whatsapp da organização'}
                        necessary name={'whatsapp'} type="tel"
                        required
                        defaultValue={data?.contact?.whatsapp && data?.contact.whatsapp}
                    />

                    <OscInput label={'Email da organização'} name={'osc_email'} important necessary
                        required
                        textInfo="E-mail da sua organização"
                        placeholder={'email@email.com'} type={"email"} defaultValue={data?.contact?.osc_email && data?.contact.osc_email}
                    />

                    <UrlInput label={'Site da organização'} type="url" name={"site"} important
                       textInfo="Site da sua organização"
                       defaultValue={data?.contact?.site && data?.contact?.site}
                    />

                    <UrlInput label={'Facebook da organização'} type="url" name={"facebook"}
                        defaultValue={data?.contact?.facebook && data?.contact.facebook}
                    />
                    <UrlInput label={'Instagram da organização'} type="url" name={"instagram"}
                        defaultValue={data?.contact?.instagram && data?.contact.instagram}
                    />
                    <UrlInput label={'Outro'} type="url" name={"other"} placeholder={"http://"}
                        defaultValue={data?.contact?.other && data?.contact.other}
                    />
                </div>
                <RespondenetFields respondent={data?.respondent && data?.respondent} />
                <div className='text-sm italic text-gray-700 pt-3'>OSC: Organização da Sociedade Civil</div>
                <div className='flex justify-between mb-3 mt-3'>
                {!load && <>
                    <div>
                         {!update && <button onClick={()=>setStep(1)} className='border border-gray-500 bg-white py-1 px-2 rounded-md'>Anterior</button>}
                    </div>

                    <div>
                        <SubmitButton value={update ? "Atualizar contatos" : "Proximo"} />
                    </div>

                </>
                }
                {load && <SpinnerLoad />}
                </div>

            </form>
        </>
    )
}

interface Props {

    oldData?:Osc
    update?:boolean
    isPublic?:boolean
}
